import React, {  useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCookie } from 'shared/utils/cookies';

import {
  KoTitle, KoForm, KoDescription,
  KoLoader
} from 'packages';

import { add, remove } from 'shared/store/breadcrumbSlice';
import { adminConsoleAPI } from '../admin.service';

import styles from './settings.module.scss';
import Preview from './preview';


function Settings(props) {
  const dispatch = useDispatch();
  const [form] = KoForm.useForm();
  const [settings, setSettings] = useState();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(remove());
    getByIdSettings();
  }, []);

  const getByIdSettings = () => {
    setLoading(true);
    const accountId = getCookie("accountId");
    adminConsoleAPI.getByIdSettings(accountId).then(
      (data) => {
        setLoading(false);
        setSettings(data['account']);
        form.setFieldsValue({ ...data['account'] });
        dispatch(add([
          {
            title: 'Admin Console',
            path: 'admin/settings'
          },
          {
            title: 'Settings'
          },
          {
            title: data['account']?.companyName
          }
        ]));
      },
      (err) => {
        setLoading(false);
      }
    );
  };




  return (
    <div className={styles.layoutMain}>
      {isLoading&& <KoLoader/>}
      <KoTitle className={styles.title} strong={true} level={5} text={`The settings for ${settings?.companyName}. have been configured.`} />
      <KoDescription className={styles.descriptionTitle} text={`All of the preferences below are directly associated
          with the current business (${settings?.companyName})
          you are currently using. Changes on this page will only affect the current business.`} />
      <div className={styles.wrapper}>
        <Preview settings={settings} form={form} getByIdSettings={getByIdSettings} />
      </div>
    </div>
  );
}

export default Settings;